import { forwardRef } from 'react';

import { TColorNames } from '@_shared/styles';

import * as S from './InputField.style';

export interface IInputProps
	extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
	color?: TColorNames;
	placeholderColor?: TColorNames;
	children?: React.ReactNode;
	borderColor?: TColorNames;
}

const InputField = forwardRef(
	(
		{ color, placeholderColor, borderColor, children, ...props }: IInputProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => (
		<S.Input color={color} placeholderColor={placeholderColor} borderColor={borderColor}>
			<input ref={ref} {...props} />
			{children}
		</S.Input>
	),
);

InputField.displayName = 'InputField';

export { InputField };
